<template>
    <div>
        <!-- 奖品池展示 -->
        <div class="blindBox-info">
            <div :class="tigerLottery ? 'tiger-prizes-title' : 'blindBox-prizes-title' "
                class="blindBox-info-title"
                :style="{'color': sectionThreeColor}">
                <div>奖品池</div>
            </div>
            <!-- 活动为轮盘锦鲤且奖品数量不超过4个-->
            <div v-if="awardNum <= 4"
                id="awardsPool"
                class="blindBox-info-reward">
                <div v-for="item in bigWheelRewardList"
                    v-show="item.goodsType != '0'"
                    :key="item.id"
                    class="blindBox-info-reward-box">
                    <img :src="item.imgUrl">
                    <div class="ellipsis ellipsis-two">{{ item.goodsName }}</div>
                </div>
            </div>
            <!--水平滚动展示奖品池-->
            <vueSeamlessScroll v-if="awardNum > 4"
                :data="bigWheelRewardList"
                :class-option="classOption"
                class="horizontal-awards-scroll">
                <ul class="ul-item">
                    <template v-for="(item, index) in bigWheelRewardList">
                        <!--未中奖，不展示-->
                        <li v-if="item.goodsType !== '0'"
                            :key="index"
                            class="li-item">
                            <img :src="item.imgUrl">
                            <div class="ellipsis ellipsis-two">{{ item.goodsName }}</div>
                        </li>
                    </template>
                </ul>
            </vueSeamlessScroll>
        </div>
    </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll';

export default {
  components: {
    vueSeamlessScroll
  },
  props: {
    sectionThreeColor: '',
    tigerLottery: '',
    awardNum: '',
    bigWheelRewardList: Array,
    // 无缝滚动组件配置项
    classOption: {
      // 开启无缝滚动的数据量
      limitMoveNum: 4,
      // 向左滚动
      direction: 2,
      // 滚动速度，值越大速度越快
      step: 0.8,
      openTouch: false,
      hoverStop: false
    }
  }
};
</script>
<style scoped lang='scss'>
.blindBox-info {
  width: 91.2%;
  margin: 20px auto 10px;
  padding: 12px 0 14px;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  .horizontal-awards-scroll {
    width: 77 * 4 px;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 7px;
    ul {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      &.ul-item {
        display: flex;
        .li-item {
          width: 67px;
          margin-right: 15px;
          text-align: center;
          img {
            width: 67px;
            height: 67px;
            margin-bottom: 7px;
          }
        }
      }
    }
  }
  .blindBox-info-reward {
    padding: 10px 0px 0px 0px;
    display: flex;
    justify-content: space-around;
    overflow: auto;

    .blindBox-info-reward-box {
      width: 67px;

      img {
        width: 15.733vw;
        height: 15.733vw;
        margin-bottom: 7px;
      }

      div {
        width: 67px;
        text-align: center;
      }
    }
  }
}
.blindBox-prizes-title {
  color: #b27d13;
  div {
    &::before {
      background: linear-gradient(to right, transparent, #b27d13);
    }
    &::after {
      background: linear-gradient(to right, #b27d13, transparent);
    }
  }
}
.tiger-prizes-title {
  div {
    &::before {
      background: linear-gradient(to right, transparent, #d7324c);
    }
    &::after {
      background: linear-gradient(to right, #d7324c, transparent);
    }
  }
}
.blindBox-info-title {
  width: 100%;
  height: 20px;
  font-family: HYQiHei-FZS;
  font-size: 16px;
  font-weight: 400;
  position: relative;

  div {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &::before {
      content: '';
      width: 40px;
      height: 3px;
      position: absolute;
      top: 50%;
      left: -60px;
    }

    &::after {
      content: '';
      width: 40px;
      height: 3px;
      position: absolute;
      top: 50%;
      right: -60px;
    }
  }
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333333;
}
.ellipsis-two {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: inherit;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/components/prize-pool.vue